export default "__VITE_ASSET__aEB673LW__"